// extracted by mini-css-extract-plugin
export default {"loadingText":"TripLoading_loadingText__e-9BQ"};